import { addLayersToMap } from "./helpers/addLayersToMap";
import { addSourcesToMap } from "./helpers/addSourcesToMap";

export function initialisePlanningApplications(map, applicationData) {
    addSourcesToMap(map, applicationData);
    addLayersToMap(map);
}